// extracted by mini-css-extract-plugin
export var chevron = "_23-d";
export var disabled = "_23-b";
export var error = "_23-c";
export var hideBorder = "_23-1";
export var icon = "_23-e";
export var input = "_23-0";
export var large = "_23-f";
export var open = "_23-9";
export var placeholder = "_23-a";
export var regular = "_23-5";
export var singleRowInput = "_23-2";
export var singleSelectInput = "_23-3 _23-0";
export var small = "_23-4";
export var spinnerContainer = "_23-i";
export var tag = "_23-7";
export var tagsContainer = "_23-8";
export var tagsInput = "_23-6 _23-0";
export var xSmall = "_23-g";
export var xxSmall = "_23-h";